import { $, $doc } from './_utils';

function customTabsActivate() {
  $('.vpth-custom-ghostkit-tabs').each(function () {
    const $this = $(this);
    const tabsId = $this.attr('data-tabs-id');

    if (!tabsId) {
      return;
    }

    const $tabs = $(`#${tabsId}.ghostkit-tabs`);

    if (!$tabs.length) {
      return;
    }

    const activeTitle = $tabs.find('.ghostkit-tabs-buttons-item-active').text();

    if (!activeTitle) {
      return;
    }

    $this
      .find('.vpth-custom-ghostkit-tabs-button-active')
      .removeClass('vpth-custom-ghostkit-tabs-button-active');

    $this.find(`button span:contains(${activeTitle})`).each(function () {
      $(this).parent().addClass('vpth-custom-ghostkit-tabs-button-active');
    });
  });
}

$doc.on('click', '.vpth-custom-ghostkit-tabs button', function (e) {
  e.preventDefault();

  const $this = $(this);
  const tabsId = $this.closest('.vpth-custom-ghostkit-tabs').attr('data-tabs-id');

  if (!tabsId) {
    return;
  }

  const $gktTabs = $(`#${tabsId}.ghostkit-tabs`);

  if (!$gktTabs.length) {
    return;
  }

  const activeTitle = $this.find('span').text();

  if (!activeTitle) {
    return;
  }

  $gktTabs.find(`.ghostkit-tabs-buttons-item:contains(${activeTitle})`).each(function () {
    this.click();
  });
});

$doc.on('activateTab.ghostkit', (event) => {
  if ('ghostkit' !== event.namespace) {
    return;
  }

  customTabsActivate();
});

customTabsActivate();
$doc.on('ready', customTabsActivate);
